jQuery(document).ready(function () {
 jQuery.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
   quickView();
 });
});
 
function quickView() {
 jQuery(".quick-view").click(function () {
   jQuery('.qv-add-button').removeClass('hide');
   jQuery(".swatches").removeClass('hide');
   if (jQuery('#quick-view').length == 0){jQuery("body").append('<div id="quick-view"></div>');}
   var product_handle = jQuery(this).data('handle');
   jQuery('#quick-view').addClass(product_handle);
   jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
     var pid = product.id;
     var title = product.title;
     var type = product.type;
     var price = 0;
     var original_price = 0;
     var desc = product.description;
     var images = product.images;
     var featured_image = product.featured_image ;
     var variants = product.variants;
     var options = product.options;
     var url = '/products/' + product_handle;
     jQuery('.qv-product-title').text(title);
     jQuery('.qv-product-type').text(type);
     jQuery('.qv-product-description').html(desc);
     jQuery('.view-product').attr('href', url);
     jQuery('.qv-add-button').attr('data-productid', pid);
     jQuery('.qv-add-button').attr('data-handle', product_handle);
     
     featured_image = '<div><img src="' + featured_image + '"></div>';
     featured_image = featured_image.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
     jQuery('.qv-product-images').append(featured_image);

     var cssRules="";
     jQuery(options).each(function (i, option) {
       var opt = option.name;
       var selectClass = '.option.' + opt.toLowerCase();
       jQuery('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
       jQuery(option.values).each(function (i, value) {
         var opt_split = value.split("__");
         var nospaces = value.replace(/\s/g, "-");
         var nospaces_split = nospaces.toLowerCase().split("__");
         var swatch_img = 'https://cdn.shopify.com/s/files/1/0470/1185/6536/files/'+nospaces.toLowerCase()+'_48x48_crop_center.png';

         var $options = jQuery('<option value="'+value+'">'+opt_split[0]+'</option>').appendTo('#SingleOptionSelector-0');
         if (opt_split[0] != "Default Title") {
         	var $lis = jQuery('<li><a data-value="'+value+'" data-vid="'+value+'" class="opt--'+nospaces_split[0]+'">'+opt_split[0]+'</a></li>').appendTo('#clickyboxes-SingleOptionSelector-0');
         }else{
           jQuery(".swatches").addClass('hide');
         }
         cssRules +='.opt--'+nospaces_split[0]+':before{background-image: url("'+swatch_img+'");}';
         
       });
     });
     jQuery('<style>'+cssRules+'</style>').appendTo('head');
     jQuery(product.variants).each(function (i, v) {
       if (v.inventory_quantity == 0) {
         jQuery('.qv-add-button').prop('disabled', true).val('Sold Out');
         jQuery('.qv-add-to-cart').hide();
         jQuery('.qv-product-price').text('Sold Out').show();
         //return true
       } else {
         price = parseFloat(v.price / 100).toFixed(2);
         original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
         jQuery('.qv-product-price').text('$' + price);
         if (original_price > 0) {
           jQuery('.qv-product-original-price').text('$' + original_price).show();
         } else {
           jQuery('.qv-product-original-price').hide();
         }
         //jQuery('select.option-0').val(v.option1);
         //jQuery('select.option-1').val(v.option2);
         //jQuery('select.option-2').val(v.option3);
         jQuery('.original-selector').append('<option value="'+v.id+'" data-stock="" data-title="'+v.title+'">'+v.title+'</option>');
         //return false
       }
     });
   });
 
   jQuery(document).on("click", "#clickyboxes-SingleOptionSelector-0 li a", function () {
     var selectedOption = jQuery(this).attr("data-value");
     jQuery('#clickyboxes-SingleOptionSelector-0 a').removeClass('active');
     jQuery(this).addClass("active");
     
     jQuery('#SingleOptionSelector-0 option').removeAttr('selected');
     jQuery('#SingleOptionSelector-0 option[value="'+selectedOption+'"]').attr("selected","selected");
     
     jQuery('.original-selector option').removeAttr('selected');
     jQuery('.original-selector option[data-title="'+selectedOption+'"]').attr("selected","selected");

     console.log("selectedOption: "+selectedOption);
     
     jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
       jQuery(product.variants).each(function (i, v) {
         if (v.title == selectedOption) {
           
           jQuery('.qv-add-button').attr('data-variantid', v.id);
           
           var price = parseFloat(v.price / 100).toFixed(2);
           var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
           var v_qty = v.inventory_quantity;
           var v_inv = v.inventory_management;
           jQuery('.qv-product-price').text('$' + price);
           jQuery('.qv-product-original-price').text('$' + original_price);
           //data-productid="" data-variantid="" data-url=""
           if (v_inv == null) {
             jQuery('.qv-add-button').prop('disabled', false).val('Add to Cart');
           } else {
             if (v.inventory_quantity < 1) {
               jQuery('.qv-add-button').prop('disabled', true).val('Sold Out');
             } else {
               jQuery('.qv-add-button').prop('disabled', false).val('Add to Cart');
             }
           }
         }
       });
     });
   });
   jQuery.fancybox({
     href: '#quick-view',
     maxWidth: 1040,
     maxHeight: 600,
     fitToView: true,
     width: '75%',
     height: '70%',
     autoSize: false,
     closeClick: false,
     openEffect: 'none',
     closeEffect: 'none',
     'beforeLoad': function () {
       var product_handle = jQuery('#quick-view').attr('class');
       jQuery(document).on("click", ".qv-add-button", function () {
         var qty = jQuery('.qv-quantity').val();
         var selectedOptions = jQuery( ".original-selector option:selected" ).attr("data-title");
         var var_id = '';
         jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
           jQuery(product.variants).each(function (i, v) {
             if (v.title == selectedOptions) {
               var_id = v.id;
               processCart();
             }
           });
         });
         function processCart() {
               //product.selected_or_first_available_variant.id
            console.log("Trying to Add to Cart");
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                quantity: qty,
                id: var_id
              },
              dataType: 'json', 
              success: function (data) { 
                console.log("success");
				jQuery('.qv-add-button').addClass('hide');
                var cartcount = parseInt(jQuery(".cart-count__text").text())+1;
                console.log("cartcount: "+cartcount);
                console.log("variant_id: "+variant_id);
                jQuery(".cart-count__text").html(cartcount);
                jQuery(".cart-count .beside-svg").html(cartcount);
				jQuery('.qv-add-to-cart-response').addClass('success').html('<span>' + jQuery('.qv-product-title').text() + ' has been added to your cart. <a href="javascript:void(0);" onclick="jQuery.fancybox.close();">Close this window.</a>');

              },
              error: function (request, status, error) {
                console.log(request.responseText);
                var message = JSON.parse(request.responseText);
                console.log(message);
                jQuery('.qv-add-to-cart-response').addClass('error').html('<span><b>OOPS: </b>' + message.description);
            }  
             });
           
         }
       });
       jQuery('.fancybox-wrap').css('overflow', 'hidden !important');
     },
     'afterShow': function () {
       jQuery('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
         jQuery('.qv-product-images').addClass('loaded');
       });
     },
     'afterClose': function () {
       jQuery('#quick-view').removeClass().empty();
     }
   });
 });
};

function addQVtoCart(){
  /*
  var add_vid = jQuery('.qv-add-button').attr('data-variantid');
  var add_hand = jQuery('.qv-add-button').attr('data-handle');
  var add_qty = jQuery('.qv-quantity').val();
  console.log ("add_vid: "+add_vid);
  console.log ("add_hand: "+add_hand);
  console.log ("add_qty: "+add_qty);
  addItemToCart(add_vid, add_qty, add_hand);
  */
}
jQuery(window).resize(function () {
 if (jQuery('#quick-view').is(':visible')) {
   jQuery('.qv-product-images').slick('setPosition');
 }
});